import BaseModelAPI from '../BaseModelAPI';

export default class MobileDeviceList extends BaseModelAPI {

	static entity = 'mobiledevicelist'
	static entityName = 'mobiledevice';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
